module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-assign-agency-d450258a5ea0f7217fe16e97052f2f8e.svg";